module.exports = __webpack_public_path__ + "img/good.21b6b324.svg";